import apiClient from './api';
import { ApiResponse, CaptchaResponseData, LoginPayload, LoginResponseData } from '../types';

export const authApi = {
  getCaptcha: (): Promise<ApiResponse<CaptchaResponseData>> =>
    apiClient.get('/admin/user/captcha'),

  login: (payload: LoginPayload): Promise<ApiResponse<LoginResponseData>> =>
    apiClient.post('/admin/user/login', payload),
};

export default authApi;
